export function csvToArray(str, separatoreCampi = ';') {
  // Carica un file csv senza spazi con tutti campi tipo stringa racchiusi da "" in un array

  // slice from start of text to the first \n index
  // use split to create an array from string by separatoreCampi
  // const separatoreRighe = '"\r\n"';
  const separatoreRighe = '\r\n';
  const headers = str.slice(0, str.indexOf(separatoreRighe)).split(separatoreCampi);
  headers.forEach((element, index, arr) => {
    arr[index] = element.trim();
  });
  // slice from separatoreRighe index + 1 to the end of the text
  // use split to create an array of each csv value row
  const rows = str.slice(str.indexOf(separatoreRighe)+2).split(separatoreRighe);
  rows.forEach((element, index, arr) => {
    if (index < (arr.length-1)) {
      arr[index] = element.slice(0,element.length);
    } else {
      arr[index] = element.slice(0,element.length-1);
    }
  });

  // Map the rows
  // split values from each row into an array
  // use headers.reduce to create an object
  // object properties derived from headers:values
  // the object passed as an element of the array
  const arr = rows.map(function (row) {
  const values = row.split(separatoreCampi);  // utilizza il separatoreCampi impostato
  // const values = CSVtoArrayB(row);   // utilizza la funzione di riconoscimento delle stringhe complesse (non devono esserci ' o ")
  const el = headers.reduce(function (object, header, index) {
      object[header] = values[index];
      return object;
    }, {});
    return el;
  });

  // return the array
  return arr;
}